/**
 * Checks window object to determine whether app is running on client or not.
 */
export const isBrowser = typeof window !== 'undefined';
